package com.xtream.data_kmp.dto


import androidx.room3.Entity
import androidx.room3.Ignore
import androidx.room3.Index
import androidx.room3.PrimaryKey
import com.xtream.data_kmp.db.utils.tryFormat
import kotlinx.serialization.SerialName

/*
    val container_extension: String,
    val rating: String,
    val rating_5based: Int,
 */
const val vodTable="vodTable"

@kotlinx.serialization.Serializable
@Entity(tableName ="vodTable",
    indices = [Index(value = ["categoryId"])],  )
data class VodStream(

    override val added: String="",

    @SerialName("category_id")
    override val categoryId: Int=-1,

    @SerialName("custom_sid")
    override val customSid: String?=null,

    @SerialName("direct_source")
    override val directSource: String?=null,

    @SerialName("is_adult")
    override val isAdult: Int=0,

    @SerialName("name")
    override val name: String="",

    @SerialName("num")
    override val num: Int?=null,

    @SerialName("stream_icon")
    override val streamIcon: String?=null,

    @SerialName("stream_id")
    @PrimaryKey
    override val streamId: Int,

    @Deprecated("streamType is deprecated", replaceWith = ReplaceWith("type"))
    @SerialName("stream_type")
    override val streamType: String="",


    @SerialName("container_extension")
    val containerExtension: String,

    @SerialName("rating")
    val rating: String?=null,

    @SerialName("rating_5based")
    val ratingFiveBased: String?=null
): BaseStream {
    @kotlinx.serialization.Transient
    @Ignore
    override val type: StreamType=StreamType.POSTER

    fun formattedRating():String=
        rating?.tryFormat(
           /* locale = Locale.ENGLISH,
            "%.1f",*/
            alt = rating
        ) ?: ""

}